<div>
  <p-tree
    id="worldRegionsTree"
    name="worldRegionsTree"
    (onNodeSelect)="nodeSelect($event)"
    (onNodeUnselect)="nodeUnselect($event)"
    [(value)]="regionCountries"
    [(selection)]="selectedBenchmarkCountryNodes"
    (onClick)="onClick()"
    selectionMode="checkbox"
    [propagateSelectionUp]="true"
    [propagateSelectionDown]="true"
    [styleClass]="styleClass"
  >
  </p-tree>
</div>
